import { useNavigate, Link } from "react-router-dom";

import {
  LogoBox,
  HeaderMenu,
  HeaderTitle
} from "./style";

import logoNuclias from "../../../../assets/img/v2/icon/logo_nuclias_cloud.png";
import iconDlink from "../../../../assets/img/v2/icon/icon_dlink.png";

import DropdownWithItem from '../../../../components/DropdownWithItem';

import User from "../../../../models/User";

import { useSelector, useDispatch } from "react-redux";

import { pageContextActions } from "../../../../stores/slice/pageContext";
import { adminPageContextActions } from "../../../../stores/slice/adminPageContext";

const AdminHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = {
    title: 'D-Link'
  };

  const logout = () => {
    User.removeTokenLocalStoreage();
    dispatch(pageContextActions.cleanAll());
    dispatch(adminPageContextActions.cleanAll());
    navigate('/login');
  };

  const userDropdownList = [
    {
      title: 'User Profile',
      icon: 'icon-user',
      navigation: './admin/user-profile',
      link: '/admin/userProfile'
    },
    {
      title: 'Log out',
      icon: 'icon icon-logout',
      navigation: '#',
      logout: true
    }
  ];

  const userDropdownClick = (item) => {
    if (item?.link) {
      navigate(item.link);
    } else if (item?.logout) {
      logout();
    }
  };

  return (
    <>
      <LogoBox>
        <Link to="/admin/dashboard"><img src={logoNuclias} alt="Nuclias" /></Link>
        <HeaderTitle>MSP Backend</HeaderTitle>
      </LogoBox>
      <HeaderMenu>
        <img
          src={iconDlink}
          className="icon btn-dropdown user"
          id="langDropdown"
          data-bs-toggle="dropdown"
          alt={user.title}
        />
        <DropdownWithItem
          id="user-dropdown"
          extendClassName="btn-dropdown-no-border"
          selectedItem={user}
          itemList={userDropdownList}
          onClick={userDropdownClick}
        />
      </HeaderMenu>

    </>
  );
};

export default AdminHeader;